
import { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Package, ArrowRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

const OrderConfirmationPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
    const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);

    // after 5 seconds, redirect to orders details page
let timer: ReturnType<typeof setTimeout> | undefined;
    if (orderId) {
      timer = setTimeout(() => {
        navigate(`/orders/${orderId}`);
      }, 5000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [navigate, orderId]);

  return (
    <>
      <Helmet><title>Order Confirmed | Bookstore</title></Helmet>
      <div className="min-h-screen bg-background py-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center animate-fade-in">
            <div className="mb-12">
              <CheckCircle className="w-24 h-24 text-success mx-auto mb-6" />
              <h1 className="text-5xl font-display font-bold text-text mb-6 leading-tight">
                Order Confirmed!
              </h1>
              <p className="text-xl text-text-secondary max-w-md mx-auto leading-relaxed">
                Thank you for your purchase. Your order has been placed successfully.
              </p>
            </div>

            {orderId && (
              <div className="bg-background-soft border border-border rounded-xl p-8 mb-10 shadow-sm">
                <p className="text-secondary text-sm font-medium uppercase tracking-wider mb-3">
                  Order ID
                </p>
                <p className="text-3xl font-display font-bold text-primary-600">
                  #{orderId.slice(0,8).toUpperCase()}
                </p>
              </div>
            )}

            <div className="bg-background-muted border border-border rounded-xl p-8 mb-12 shadow-sm animate-slide-in-from-top-1">
              <Package className="w-16 h-16 text-primary-500 mx-auto mb-4" />
              <h3 className="text-2xl font-display font-semibold text-text mb-3">
                Estimated Delivery
              </h3>
              <p className="text-lg text-text-secondary leading-relaxed">
                Your order will be delivered within 5-7 business days.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link
                to="/orders"
                className="group btn-primary inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-xl transition-all duration-fast hover:shadow-lg transform hover:-translate-y-0.5"
              >
                View Order
                <ArrowRight className="w-5 h-5 ml-3 group-hover:translate-x-1 transition-transform duration-fast" />
              </Link>
              <Link
                to="/products"
                className="btn-secondary inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-xl border-2 border-border transition-all duration-fast hover:bg-background-soft hover:border-primary-300"
              >
                Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderConfirmationPage;